export default "__VITE_ASSET__ClJPI3as__"